import * as Sentry from "@sentry/react";
import { SENTRY_DNS } from "@/core/sentry";


export const sentryReport = (e: any) => {
  if (SENTRY_DNS) {
    Sentry.captureException(e);
  }
}
